import React from 'react';
import { enumHelper } from '../../utils';
import ENUMS from '../../enums/index';
import { NavLink } from 'react-router-dom';

const renderStatusColors = scheduleStatus => {
  switch (scheduleStatus) {
    case 'ACTIVE':
      return 'text-success';
    case 'DISABLE':
      return 'text-danger';
    default:
      return 'text-info';
  }
};

export const packagesListColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام بسته',
    dataIndex: 'name',
    name: 'name',
    isSortable: true,
  },
  {
    title: 'تعداد صندلی',
    dataIndex: 'numberOfRsee',
    name: 'numberOfRsee',
    isSortable: true,
  },
  {
    title: 'قیمت بسته',
    dataIndex: 'price',
    name: 'price',
    isSortable: true,
    render: price => (
      <div>{Number(price).toLocaleString()}</div>
    ),
  },
  {
    title: 'تاریخ ایجاد بسته',
    dataIndex: 'createdAt',
    name: 'createdAt',
    isSortable: true,
  },
  {
    title: 'وضعیت',
    dataIndex: 'status',
    name: 'status',
    isSortable: false,
    render: status => (
      <div className={renderStatusColors(status)}>
        {enumHelper.convertEnumValueToTitle(ENUMS.PACKAGE_STATUS.list, status)}
      </div>
    ),
  },
  {
    title: 'ویرایش',
    dataIndex: '',
    name: '',
    isSortable: false,
    permission: ENUMS.PERMISSIONS.values.EDIT_RSEE_PACKAGE,
    action: item => (
      <NavLink
        to={{
          pathname: '/packages/management/add-or-edit-package',
          editMode: true,
          item: item,
        }}
        title={locales('edit.package')}
      >
        <i className="text-center fa fa-pencil text-secondary pointer" />
      </NavLink>
    ),
  },
];